var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{staticStyle:{"height":"5em","position":"absolute","left":"42%","top":"45%"},attrs:{"src":require("../assets/img/logo_main.png")}})])
}]

export { render, staticRenderFns }